export default "__VITE_ASSET__Cz1XB8sZ__"